import React, { Fragment, useState } from "react";
import { Container, Button, Grid } from "@material-ui/core";
import { Images } from "utils";

export const TransportCore = () => {
  /**
   * Header Core.
   */

  const handleLogIn = () => {};

  return (
    <Fragment>
      <Grid container spacing={6}>
        <Grid item xs={12} md={6} className="order-content">
          <div className="column">
            <h2 className="title-we">
              Expert Transportation Services for Your Peace of Mind
            </h2>
            <div className="box-text">
              <p className="type-text">
                At our logistics company, we understand that time is of the
                essence when it comes to shipping your goods. That's why we
                offer a range of services to ensure that your shipments arrive
                at their destination in a timely and cost-effective manner. From
                air freight to ocean freight, ground transportation to
                warehousing and distribution, we have the expertise and
                resources to handle all of your logistics needs.
              </p>
            </div>
          </div>
        </Grid>
        <Grid item xs={12} md={6} className="order-img">
          <img src={Images.Transportation} alt="" className="full-img" />
        </Grid>
      </Grid>
    </Fragment>
  );
};
